import React, { useRef } from "react";
import { Col, Form, Modal, Row, Select, message } from "antd";
import { connect } from "dva";
import { router } from "umi";
import { getUrlParams } from "@/utils/utils";

const handleDelete = (shipmentData, dispatch, deleteReasonFormRef) => {
  const urlEntityId = getUrlParams("entityId");

  deleteReasonFormRef.current.validateFields().then(result => {
    const { id: shipmentId, entityId } = shipmentData;
    const { reason } = result;

    dispatch({
      type: "shipmentDetails/toggleDeleteReasonModalVisible",
      payload: false,
    }).then(() => {
      const hide = message.loading("Deleting");
      dispatch({
        type: "shipmentDetails/removeShipment",
        payload: { shipmentId, entityId, deletedReason: reason },
      }).then(res => {
        hide();
        if (res.error) {
          message.error("Could not delete shipment. Please contact Autosled support.");
        } else {
          message.success("Successfully deleted shipment.");
          if (urlEntityId) {
            router.push(`/shipments/dealer/all?entityId=${urlEntityId}`);
          } else {
            router.push(`/shipments/dealer/all`);
          }
        }
      });
    });
  });
};

const DeleteReasonModal = props => {
  const { shipmentData, deleteReasonModalVisible, dispatch } = props;

  const { Option } = Select;

  const deleteReasonFormRef = useRef();

  return (
    <Modal
      title="Delete Shipment"
      open={deleteReasonModalVisible}
      onOk={() => {
        handleDelete(shipmentData, dispatch, deleteReasonFormRef);
      }}
      onCancel={() => {
        dispatch({
          type: "shipmentDetails/toggleDeleteReasonModalVisible",
          payload: false,
        });
      }}
    >
      <Form layout="vertical" ref={deleteReasonFormRef}>
        <Row gutter={16}>
          <Col lg={24}>
            <p>
              Please enter reason for deleting shipment. <br />
            </p>
            <Form.Item name="reason" label="Reason" rules={[{ required: true }]}>
              <Select>
                <Option key="price" value={1}>
                  Price
                </Option>
                <Option key="noLongerNeeded" value={2}>
                  No Longer Needed
                </Option>
                <Option key="dealFellThrough" value={3}>
                  Deal Fell Through
                </Option>
                <Option key="vehicleMechanicalIssues" value={4}>
                  Vehicle Mechanical Issues
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(({ shipmentDetails }) => ({
  shipmentData: shipmentDetails.data,
  deleteReasonModalVisible: shipmentDetails.deleteReasonModalVisible,
}))(DeleteReasonModal);
